import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative flex min-h-[86vh] items-center justify-center overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20vibrant%20illustration%20of%20a%20fantasy%20webtoon%20landscape%20with%20floating%20magical%20books%2C%20flying%20swords%2C%20sakura%20petals%20and%20an%20ancient%20temple%2C%20dreamy%20manhwa%20art%20style%2C%20rich%20warm%20terracotta%20and%20gold%20color%20palette%2C%20atmospheric%20glow%2C%20artistic%20and%20abstract&width=1600&height=1000&seq=hero-main-2026&orientation=landscape"
        alt="韩国漫画大全 奇幻、校园、古风题材插画背景"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/55 to-foreground-950/85" aria-hidden="true" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-foreground-950/40 px-4 py-1.5 text-sm text-accent-300 backdrop-blur">
          <i className="ri-sparkling-2-fill text-accent-400" aria-hidden="true" />
          按题材发现你的下一部韩漫
        </span>
        <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
          韩国漫画<span className="text-accent-400">大全</span>
          <span className="block text-xl font-semibold text-background-200 md:text-2xl">
            奇幻 · 校园 · 古风，一篇逛遍好作品
          </span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
          韩国漫画大全按韩漫大全类型整理专题，从异世界热血冒险到甜度爆表的青春恋爱，再到华美古风权谋，
          帮你快速定位偏好题材，持续发现同类佳作。
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            浏览全部作品
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
          <Link
            to="/category/fantasy"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-sword-fill" aria-hidden="true" />
            进入奇幻专题
          </Link>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {[
            { num: "3", label: "核心题材专题" },
            { num: "15+", label: "精选佳作" },
            { num: "500+", label: "累计收录章节" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{s.num}</div>
              <div className="mt-1 text-xs text-background-300">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 animate-bounce text-background-200/70" aria-hidden="true">
        <i className="ri-arrow-down-s-line text-2xl" />
      </div>
    </section>
  );
}